import {createSelector} from '@reduxjs/toolkit';
import {addDays, endOfDay, isWithinInterval, parseISO} from 'date-fns';
import {RootState} from '../../rootReducer';
import {getStartOfTodayISOString} from '../settings';
import {dayNamesToISODays, isoDaysContainsDate} from '@lib/utils';

export const getAccessProfile = (state: RootState) => state.data.profiles.effectiveAccessProfile;

export const getLocationProfile = (state: RootState) => state.data.profiles.effectiveLocationProfile;

export const getIsLoadingProfiles = (state: RootState) => state.data.profiles.isLoading;

export const getParkingQuotaProfile = (state: RootState) => state.data.profiles.parkingQuotaProfile;

export const getParkingLocationProfile = (state: RootState) => state.data.profiles.parkingLocationProfile;

export const getIsNewUserSession = (state: RootState) => state.data.profiles.isNewUserSession;

export const getIsSelectedDateFuture = createSelector(
  getStartOfTodayISOString,
  getAccessProfile,
  (_state: RootState, date: Date) => date,
  (todayISOString, {daysAhead}, date) => {
    const today = parseISO(todayISOString);
    const lastBookableDay = endOfDay(addDays(today, daysAhead));
    return !isWithinInterval(date, {start: today, end: lastBookableDay});
  },
);

export const getIsDayAllowed = createSelector(
  getAccessProfile,
  (_: RootState, date: Date) => date,
  ({registrationDays}, date) => {
    const registrationISODays = dayNamesToISODays(registrationDays);
    return isoDaysContainsDate(date)(registrationISODays);
  },
);
